<h3 class="chart-title">
	<slot/>
</h3>

<style>
	.chart-title {
	font-size: 1.1em;
	margin-bottom: 10px;
	color: #222222;
	font-weight: 700;
	font-size: 22px;
	}
</style>